import React, {isValidElement} from 'react';
import { useTranslation } from "react-i18next";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const OutputType = (props) => {
    const {type,subaccount,subaccountIndex,checkboxHandler,fieldHandler,onInputChange,isDefault} = props;
    const {t, i18n} = useTranslation();
    if(!type) return '';
    //console.log('[OutputType.js] received props',props);

    let key;
    if(isDefault) key = 'default-'+type;
    else key = subaccount.infos.subAccountCode+'-'+type;

    const currentConfig = subaccount.configs[type];
    const enabled = currentConfig.checked;

    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const regexPhone = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i;

    let fieldType;
    switch(type){
        case 'email': fieldType = 'email'; break;
        case 'phone': fieldType = 'tel'; break;
        case 'sms': fieldType = 'tel'; break;
        default : fieldType = 'text'; break;
    }
    const isContentValid = (field) => {
        if(field === ''){
            return false
        }
        return field.length > 0 && regex.test(field)  === false
    }
    const isPhoneValid = (field) => {
        if(field === ''){
            return false
        }
        return field.length > 0 && regexPhone.test(field)  === false
    }

    const renderField = (fieldIndex,fieldValue) => {
        return (
            <div className="input-field" key={key+'-'+fieldIndex}>
                <div className="control">
                    <input type={fieldType}
                           id={key+'-'+fieldIndex}
                           name={key+'-'+fieldIndex}
                           value={fieldValue}
                           autoComplete={"false"}
                           onChange={(e) => {
                               if(fieldType === 'email'){
                                   if(isContentValid(e.target.value)){
                                       props.validate(true);
                                   }else{
                                       props.validate(false);
                                   }
                                   onInputChange(subaccountIndex,type,fieldIndex,isDefault,e.target.value)
                               }else if(fieldType === 'tel'){
                                   if(isPhoneValid(e.target.value)){
                                       props.validate(true);
                                   }else{
                                       props.validate(false);
                                   }
                                   onInputChange(subaccountIndex,type,fieldIndex,isDefault,e.target.value)
                               }else{
                                   onInputChange(subaccountIndex,type,fieldIndex,isDefault,e.target.value)
                               }
                             }
                           }
                           disabled={!enabled}
                    />
                    { fieldType === 'email' && isContentValid(fieldValue)  ?
                        <span className="span span--c-red"> {  }
                            {t('profile.notifications.emailerror')}
                        </span> : ''
                    }
                    { fieldType === 'tel' && isPhoneValid(fieldValue)  ?
                        <span className="span span--c-red"> {  }
                            {t('profile.notifications.phoneerror')}
                        </span> : ''
                    }
                </div>
                {(fieldIndex > 0 && enabled) &&
                    <button className="btn btn--delete"
                            title={t('profile.notifications.buttons.delete')}
                            onClick={(e) => {
                                e.preventDefault();
                                fieldHandler(subaccountIndex,type,false,fieldIndex,isDefault);
                            }}>
                        <span className="visually-hidden">
                            {t('profile.notifications.buttons.delete')}
                        </span>
                        <span className="btn__icon">
                            <i className="fas fa-minus-circle"></i>
                        </span>
                    </button>
                }
            </div>
        );
    }

    return(
        <fieldset className={(!enabled)?'notification-management__recipients notification-management__'+type+' notification-management__recipients--disabled':'notification-management__recipients  notification-management__'+type}
                  key={key}>
            <label className="checkbox-field checkbox-field--gray mb-2 mt-1" htmlFor={key+'-chk'} title="Enable/disable">
                <input type="checkbox"
                       id={key+'-chk'}
                       name={key+'-chk'}
                       onChange={(e) => {
                           checkboxHandler(subaccountIndex,type,e.target.checked,isDefault);
                       }}
                       checked={enabled}
                />
                <span className="fake-check" />
                <div className="d-flex">
                    <strong>
                        {t('profile.notifications.outputs.'+type)}

                    </strong>
                    <OverlayTrigger placement='bottom'
                                    overlay={<Tooltip id="tooltip-right" >
                                        {t('profile.notifications.activedisable')}
                                    </Tooltip>}>
                        <div className="btn-info-tooltip btn-info-tooltip--inline"><i
                            className="far fa-info-circle"></i></div>
                    </OverlayTrigger>
                </div>

            </label>
            {
                Array.isArray(currentConfig.fields) ? currentConfig.fields.map((fieldValue,fieldIndex) => {
                        return renderField(fieldIndex,fieldValue);
                    }) : renderField(0,'')
            }
            <div className="notification-management__recipients__actions">
                {
                    (enabled) && (

                        <button className="link link--red link--underline link--fs-14 notification-management__recipients__action"
                                onClick={(e) => {
                                    e.preventDefault();
                                    let parent = e.target.parentNode.parentNode;
                                    let items = parent.querySelectorAll(".input-field");
                                    if(items.length >= 1){
                                        if(items[items.length - 1].querySelector('input').value !== ''){
                                            fieldHandler(subaccountIndex,type,true,0,isDefault);
                                        }
                                    }else{
                                        fieldHandler(subaccountIndex,type,true,0,isDefault);
                                    }

                                }}>
                            {t('profile.notifications.buttons.add')}
                        </button>
                    )
                }

            </div>
        </fieldset>
    );
};

export default OutputType;
